module.exports = __webpack_public_path__ + "img/全部注入.a0fad394.svg";